<template>
  <div class="more-information">
    <!-- More Information -->

    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100 px-0">
        <md-card class="card-content">
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">{{ $t("student.medical") }}</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <file-list
              :list.sync="form.medical"
              list-name="mi-list"
              ref="medicalRef"
            ></file-list>
          </md-card-content>
        </md-card>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100 px-0 lg:pl-3">
        <md-card class="card-content">
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">
                {{ $t("student.financial_assistance_programs") }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <file-list
              :list.sync="form.financial_assistance_programs"
              list-name="fap-list"
              ref="fapRef"
            ></file-list>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import FileList from "./FileList";
import { getPieceObj, Message, initLoader } from "@/helpers/utils";
import { postFileToS3 } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";

export default {
  name: "student-restrict",
  components: {
    FileList
  },
  data() {
    const initialFormData = {
      medical: [],
      financial_assistance_programs: []
    };
    return {
      form: initialFormData
    };
  },
  inject: ["updateStudentData"],
  methods: {
    async getFormData() {
      try {
        const formattedForm = await this.uploadNewFilesToS3(this.form);

        return formattedForm;
      } catch (error) {
        Message.error(this.$t("student.cant_save_your_file_to_s3"));
      }
    },

    async uploadNewFilesToS3(formData) {
      const { medical, financial_assistance_programs } = formData;
      const loader = initLoader();

      if (medical) {
        for await (let mdcData of medical) {
          if (!mdcData.obj) continue;

          mdcData.src = await this.uploadFileToS3(mdcData.obj);

          delete mdcData.obj;
        }
      }

      if (financial_assistance_programs) {
        for await (let fapData of financial_assistance_programs) {
          if (!fapData.obj) continue;

          fapData.src = await this.uploadFileToS3(fapData.obj);

          delete fapData.obj;
        }
      }

      loader.hide();

      return {
        medical,
        financial_assistance_programs
      };
    },

    loadData(data) {
      const newFormData = getPieceObj(this.form, data);
      this.form = Object.assign({}, this.form, newFormData);
    },

    uploadFileToS3(file) {
      return postFileToS3(`${AWSConst.S3_STUDENTS_UPLOAD_PATH}/restrict`, file);
    },

    async updateAccount() {
      try {
        const formartedForm = await this.getFormData();
        const studentData = await this.updateStudentData(formartedForm);

        if (studentData) {
          const newFormData = getPieceObj(this.form, studentData);
          this.form = Object.assign({}, newFormData);
        }
      } catch (error) {
        Message.error(this.$t("student.update_student_failed"));
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
